import * as THREE from "three";

exports.Unify = function(unify) {
  this.unify_id = "sounds";

  unify.assetLoader.loadAudio("audio/bad_bass.mp3", "bad_bass");
  unify.assetLoader.loadAudio("audio/low_bwap_short.mp3", "bwap_short");
  unify.assetLoader.loadAudio("audio/gong_pulse.mp3", "gong_pulse");
  unify.assetLoader.loadAudio("audio/low_sweep1.mp3", "low_sweep");
  unify.assetLoader.loadAudio("audio/synth_gruv_2bar_loop.mp3", "gruv_loop");
  unify.assetLoader.loadAudio("audio/low_shock.mp3", "low_shock");
  unify.assetLoader.loadAudio("audio/arp_up1.mp3", "powerUp_loop");
  unify.assetLoader.loadAudio("audio/runaway_cut.mp3");

  const playerListener = new THREE.AudioListener();
  unify.camera.add(playerListener);

  const soundPlayers = [];
  const hitEvilNug = new THREE.Audio(playerListener);
  const evilMusicLoop = new THREE.Audio(playerListener);
  const playerDamage = new THREE.Audio(playerListener);
  const killEnemy = new THREE.Audio(playerListener);
  const hitGoodNug = new THREE.Audio(playerListener);
  const powerUpLoop = new THREE.Audio(playerListener);
  const music = new THREE.Audio(playerListener);

  this.awake = () => {
    // subscribe gameLogic world state event
    unify.modules.gameLogic.addEvent_WorldState(setState);
    // TEMP 'q' tp mute audio
    unify.input.addKeyDown(toggleVolume, "q");
  };

  this.start = () => {
    music.setBuffer(unify.assets.audioBuffers.runaway_cut);
    music.setLoop(true);
    music.setVolume(0.25);

    // 0
    hitEvilNug.setBuffer(unify.assets.audioBuffers.low_sweep);
    soundPlayers.push(hitEvilNug);
    // 1
    evilMusicLoop.setBuffer(unify.assets.audioBuffers.bad_bass);
    evilMusicLoop.setVolume(0.2);
    evilMusicLoop.setLoop(true);
    evilMusicLoop.play();
    evilMusicLoop.stop();
    soundPlayers.push(evilMusicLoop);
    // 2
    playerDamage.setBuffer(unify.assets.audioBuffers.low_shock);
    soundPlayers.push(playerDamage);
    // 3
    killEnemy.setBuffer(unify.assets.audioBuffers.bwap_short);
    soundPlayers.push(killEnemy);
    // 4
    hitGoodNug.setBuffer(unify.assets.audioBuffers.gong_pulse);
    soundPlayers.push(hitGoodNug);
    // 5
    powerUpLoop.setBuffer(unify.assets.audioBuffers.powerUp_loop);
    powerUpLoop.play();
    powerUpLoop.stop();
    powerUpLoop.setVolume(0.75);
    powerUpLoop.setLoop(true);
    soundPlayers.push(powerUpLoop);
  };

  // 0 - hit evil nugget
  // 1 - evil music loop
  // 2 - player damamge buzz
  // 3 - enemy kill bwap
  // 4 - hit good nugget
  // 5 - power up loop

  this.play = function() {
    for (let i = 0; i < arguments.length; i++) {
      if (soundPlayers[arguments[i]]) soundPlayers[arguments[i]].play();
    }
  };

  this.stop = function() {
    for (let i = 0; i < arguments.length; i++) {
      if (soundPlayers[arguments[i]]) {
        soundPlayers[arguments[i]].play();
        soundPlayers[arguments[i]].stop();
      }
    }
  };

  this.getMusic = () => {
    return music;
  };

  const setState = state => {
    switch (state) {
      case -1:
        music.play();
        break;
      case 0:
        this.stop(1, 5);
        music.play();
        break;
      case 1:
        this.stop(0, 1);
        this.play(4, 5);
        music.pause();
        break;
      case 2:
        this.stop(4, 5);
        this.play(0, 1);
        music.pause();

        break;
    }
  };

  const toggleVolume = function() {
    if (playerListener.getMasterVolume() == 0) playerListener.setMasterVolume(1);
    else playerListener.setMasterVolume(0);
  };
};
